import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<'terms' | 'privacy' | null>(null);
  return <footer className="bg-cream py-12 border-t border-sage/20" data-id="element-64">
      <div className="container mx-auto px-6 max-w-5xl text-center" data-id="element-65">
        <h3 className="font-serif text-2xl text-forest mb-6 italic" data-id="element-66">
          Adiós Inflamación
        </h3>

        <p className="text-xs text-charcoal/50 max-w-3xl mx-auto leading-relaxed mb-8" data-id="element-67">
          Descargo de responsabilidad: La información proporcionada en este
          libro electrónico y en esta página web es únicamente para fines
          educativos e informativos. No pretende sustituir el consejo,
          diagnóstico o tratamiento médico profesional. Siempre busque el
          consejo de su médico u otro proveedor de salud calificado con
          cualquier pregunta que pueda tener con respecto a una condición
          médica.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-charcoal/60" data-id="element-68">
          <span data-id="element-69">
            &copy; {new Date().getFullYear()} Adiós Inflamación. Todos los
            derechos reservados.
          </span>
          <span className="hidden md:inline" data-id="element-70">•</span>
          <button type="button" onClick={() => setOpenModal('terms')} className="hover:text-sage transition-colors underline-offset-4 hover:underline" data-id="element-71">
            Términos y Condiciones
          </button>
          <span className="hidden md:inline" data-id="element-72">•</span>
          <button type="button" onClick={() => setOpenModal('privacy')} className="hover:text-sage transition-colors underline-offset-4 hover:underline" data-id="element-73">
            Política de Privacidad
          </button>
        </div>
      </div>

      {/* Términos y Condiciones */}
      <LegalModal open={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-74">
        <p className="text-xs text-charcoal/50" data-id="element-75">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-76">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-77">
          Al acceder y utilizar este sitio web y adquirir el producto digital
          "Adiós Inflamación — Protocolo de 48 Horas", aceptas estar legalmente
          vinculado por los siguientes términos y condiciones. Si no estás de
          acuerdo con alguno de ellos, te pedimos que no utilices el sitio ni
          adquieras el producto.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-78">
          2. Naturaleza del Producto
        </h3>
        <p data-id="element-79">
          "Adiós Inflamación" es un libro electrónico (ebook) en formato PDF de
          carácter educativo e informativo. La información ofrecida no
          constituye consejo médico, diagnóstico ni tratamiento. Antes de
          realizar cualquier cambio en tu dieta, estilo de vida o medicación,
          consulta siempre con un profesional sanitario cualificado.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-80">
          3. Licencia de Uso
        </h3>
        <p data-id="element-81">
          Al adquirir el producto, recibes una licencia personal, no exclusiva e
          intransferible para descargar, leer y consultar el contenido para tu
          uso individual. Queda expresamente prohibido reproducir, redistribuir,
          revender, publicar o compartir total o parcialmente el contenido sin
          autorización previa por escrito.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-82">
          4. Entrega Digital
        </h3>
        <p data-id="element-83">
          El producto se entrega de forma inmediata tras la confirmación del
          pago, mediante un enlace de descarga digital. No se envían productos
          físicos. Es responsabilidad del usuario asegurar que dispone de un
          dispositivo y software compatibles para visualizar archivos PDF.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-84">
          5. Política de Reembolso
        </h3>
        <p data-id="element-85">
          Ofrecemos una garantía de satisfacción de 30 días. Si dentro de ese
          periodo consideras que el producto no cumple con lo prometido, podrás
          solicitar el reembolso íntegro del importe abonado mediante el canal
          habilitado al efecto.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-86">
          6. Limitación de Responsabilidad
        </h3>
        <p data-id="element-87">
          El uso de la información contenida en este ebook es bajo la exclusiva
          responsabilidad del lector. No nos hacemos responsables de resultados
          específicos, reacciones adversas o decisiones tomadas a partir del
          contenido. Los resultados pueden variar entre personas.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-88">
          7. Propiedad Intelectual
        </h3>
        <p data-id="element-89">
          Todos los textos, imágenes, gráficos, logotipos y demás elementos del
          sitio y del ebook están protegidos por derechos de propiedad
          intelectual y son propiedad de "Adiós Inflamación". Su uso no
          autorizado puede dar lugar a acciones legales.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-90">
          8. Modificaciones
        </h3>
        <p data-id="element-91">
          Nos reservamos el derecho a modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor desde su publicación en este
          sitio web. Se recomienda revisar esta sección periódicamente.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-92">
          9. Legislación Aplicable
        </h3>
        <p data-id="element-93">
          Estos términos se rigen por la legislación vigente. Cualquier
          controversia derivada de su interpretación o cumplimiento se someterá
          a los tribunales competentes del domicilio del titular del servicio.
        </p>
      </LegalModal>

      {/* Política de Privacidad */}
      <LegalModal open={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-94">
        <p className="text-xs text-charcoal/50" data-id="element-95">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-96">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-97">
          Recopilamos únicamente la información estrictamente necesaria para
          procesar tu compra y entregarte el producto digital, incluyendo:
          nombre, dirección de correo electrónico y datos de facturación
          gestionados a través de nuestra pasarela de pago segura.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-98">
          2. Uso de la Información
        </h3>
        <p data-id="element-99">
          Los datos recopilados se utilizan exclusivamente para: procesar tu
          pedido, enviarte el enlace de descarga, gestionar reembolsos si los
          solicitas, y enviarte comunicaciones relacionadas con el producto que
          has adquirido. Nunca venderemos ni cederemos tus datos a terceros con
          fines comerciales.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-100">
          3. Pasarela de Pago
        </h3>
        <p data-id="element-101">
          Los pagos se procesan a través de proveedores externos certificados.
          No almacenamos en ningún momento los datos completos de tu tarjeta de
          crédito ni información financiera sensible en nuestros servidores.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-102">4. Cookies</h3>
        <p data-id="element-103">
          Este sitio puede utilizar cookies técnicas y de análisis para mejorar
          la experiencia del usuario y entender cómo interactúan los visitantes
          con la página. Puedes desactivar las cookies en la configuración de tu
          navegador, aunque ciertas funcionalidades podrían verse afectadas.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-104">
          5. Comunicaciones por Correo
        </h3>
        <p data-id="element-105">
          Si decides suscribirte voluntariamente a nuestras comunicaciones,
          podrás darte de baja en cualquier momento mediante el enlace de
          cancelación incluido en cada correo. No realizamos prácticas de envío
          no consentido (spam).
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-106">6. Seguridad</h3>
        <p data-id="element-107">
          Aplicamos medidas técnicas y organizativas razonables para proteger la
          información personal contra acceso no autorizado, alteración,
          divulgación o destrucción. Sin embargo, ningún sistema en línea es
          completamente impenetrable.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-108">
          7. Derechos del Usuario
        </h3>
        <p data-id="element-109">
          Tienes derecho a acceder, rectificar, suprimir, oponerte al
          tratamiento, así como a la portabilidad de tus datos personales. Estos
          derechos pueden ejercerse mediante los canales habilitados en este
          sitio.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-110">
          8. Conservación de los Datos
        </h3>
        <p data-id="element-111">
          Conservaremos tus datos durante el tiempo necesario para cumplir con
          las finalidades para las que fueron recogidos y para atender las
          obligaciones legales aplicables, en particular las obligaciones
          fiscales y contables.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-112">
          9. Menores de Edad
        </h3>
        <p data-id="element-113">
          Este sitio y producto están dirigidos a personas mayores de edad. No
          recopilamos conscientemente datos personales de menores. Si detectamos
          datos de un menor, los eliminaremos de forma inmediata.
        </p>

        <h3 className="font-serif text-lg text-forest mt-4" data-id="element-114">
          10. Cambios en la Política
        </h3>
        <p data-id="element-115">
          Podemos actualizar esta política ocasionalmente para reflejar cambios
          legales o de funcionamiento. La versión vigente será siempre la
          publicada en este sitio web, con su correspondiente fecha de
          actualización.
        </p>
      </LegalModal>
    </footer>;
}